import ActivityHistoryPage from "../components/activityHistory/main";

const ActivityHistory = () => {
  return <ActivityHistoryPage />;
};

export default ActivityHistory;
